const ru = {
  onboarding: {
    countryQuestion: "Понятно! 🌍\n\nВ какой стране вы находитесь?",
    countryPlaceholder: "В какой стране вы находитесь?",
    letsGo: "Поехали!",
    summaryIntro: "🎉 Отлично, {name}! Всё готово!",
    yourNameLabel: "ваше имя",
    baseLanguageLabel: "базовый язык",
    goalsHint: "Вы можете изменить цель по словарному запасу и продолжительность курса в любое время на странице Цели.",
    startLearning: "Начать изучение {destLang}!",
  },
  header: {
    learner: "Ученик",
    home: "🏠 Главная",
    allLessons: "📚 Все уроки",
    currentLesson: "📖 Текущий урок",
    flashcards: "🃏 Карточки",
    progress: "📈 Прогресс",
    goals: "🎯 Цели",
    grammarLab: "📘 Грамматика",
    more: "⋯ Ещё",
    myVocabulary: "📝 Мой словарь",
    listenSpeak: "🎧 Слушай и говори",
    signOut: "↩ Выйти",
  },
  lab: {
    title: "Лаборатория «Слушай и говори»",
    back: "Назад",
    intro: "Проведите короткий устный разговор с Баби на тему, которую вы уже изучили.",
    pickTopic: "Выберите завершённую тему",
    noTopics: "Сначала завершите урок, затем вернитесь сюда, чтобы попрактиковаться в речи.",
    level: "Уровень {level}",
    talkAbout: "Поговорите с Баби о «{topic}»",
    speedLabel: "Скорость Баби",
    speedNormal: "Обычная",
    speedSlow: "Медленная",
    speedNote: "Медленная скорость расходует больше голосовых минут на тот же ответ.",
    startConversation: "Начать разговор",
    tapToStart: "Нажмите на микрофон и ответьте Баби по-турецки.",
    continueConversation: "Ответьте на вопрос",
    finishSession: "Завершить",
    voiceReviewHint: "Проверьте, что вы сказали, и подтвердите — или запишите заново.",
    voiceConfirm: "Подтвердить",
    voiceRedo: "Заново",
    voiceDenied: "Голос недоступен без доступа к микрофону. Нажмите на значок микрофона в любое время, чтобы попробовать снова.",
    lowBalanceWarning: "У вас заканчиваются голосовые минуты на этот месячный цикл.",
    thinking: "Баби думает…",
    complete: "Сессия завершена",
    completeSub: "Хорошая практика. Возвращайтесь в любое время, чтобы поговорить о другой теме.",
    another: "Попрактиковать другую тему",
    done: "Готово",
    replyError: "Баби не смог ответить сейчас. Пожалуйста, попробуйте ещё раз через мгновение.",
    tryAgain: "Повторить",
    eliteUpsellTitle: "«Слушай и говори» — функция Elite",
    eliteUpsellBody: "У вас план Pro. Перейдите на Elite в Настройках, чтобы практиковать речь с Баби.",
    listenAgainButton: "Слушать снова",
    listenAgainPlaying: "Стоп",
    translateButton: "Перевести",
    translating: "Перевод…",
    translateFailed: "Не удалось перевести — попробуйте ещё раз.",
    starsAriaLabel: "{stars} из 3",
    explainButton: "Объяснить подробнее",
    explaining: "Объяснение…",
    explainFailed: "Не удалось получить объяснение — попробуйте ещё раз.",
    recapHeading: "Отчёт о разговоре",
    recapTitle: "Ваш итог",
    recapAvgStars: "Среднее за эту сессию",
    recapTurnsCompleted: "{completed} из {total} ходов завершено",
    recapErrorFree: "{n} ходов без ошибок",
    recapMistakesByType: "Ошибки по типу",
    recapCorrections: "Что было исправлено",
    voiceMinutesTitle: "Голосовые минуты",
    voiceMinutesLeft: "{amount} из {total} осталось в этом цикле",
    voiceMinutesNone: "В этом цикле месячные минуты закончились",
  },
  dashboard: {
    greeting: "Привет, {name}! 👋",
    streakMsg: "Серия {streak} дней 🔥 — продолжайте!",
    noStreak: "Начните первый урок сегодня!",
    streakProtectionDays: "{n} дней защиты серии заработано 🛡️",
    dayInfo: "Базовый язык: {lang} · День {day} из {total}",
    dayStreak: "дней подряд",
    share: "Поделиться",
    wordsLearned: "Изученные слова",
    lessonsDone: "Пройденные уроки",
    goalComplete: "Выполнено цели",
    timeStudied: "Время обучения",
    hoursUnit: "Часов",
    paceTitle: "📊 Ежедневный трекер темпа",
    statusAhead: "🚀 На {delta} слов впереди!",
    statusBehind: "⚡ {delta} слов нужно наверстать",
    statusOnTrack: "✅ Строго по плану!",
    paceTarget: "Цель: {wpd} слов/день · Сегодня: {today} слов",
    paceExpected: "Ожидается: {n}",
    paceGoal: "Цель: {n}",
    actionCurrentLesson: "Текущий урок",
    actionAllLessons: "Все уроки",
    actionFlashcards: "Карточки",
    actionProgress: "Мой прогресс",
    actionGoals: "Мои цели",
    actionMyVocabulary: "Мой словарь",
    actionGrammarLab: "Лаборатория грамматики",
    actionListenSpeak: "Лаборатория «Слушай и говори»",
    lessonsSub: "{count} тем · {words} слов",
    cardsDue: "{n} карточек сегодня!",
    allCaughtUp: "Всё пройдено! 🎉",
    progressSub: "Графики, точность, рост словарного запаса",
    myVocabSub: "Просмотрите все изученные слова",
    listenSpeakSub: "Практикуйте речь с Баби",
    goalsSub: "{words} слов · {days} дней",
    apiCost: "💰 Трекер затрат API",
    since: "с {date}",
    resetBtn: "↺ Сбросить",
    totalTokens: "всего токенов",
    inputTokens: "ввод",
    outputTokens: "вывод",
    estCost: "прим. стоимость",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "Совет:",
    tips: [
      "В турецком глагол всегда стоит в конце предложения — «Ben kahve içiyorum» означает «Я кофе пью.» Просто впитывайте паттерны!",
      "Турецкий использует гармонию гласных — суффиксы меняют гласные в соответствии с последней гласной корня (напр. -lar/-ler, -da/-de). Как только замечаешь это, всё становится понятным!",
      "В турецком нет грамматического рода. Ни мужского, ни женского — на одно правило меньше, чем во французском, испанском или немецком!",
      "Личные местоимения (ben = я, sen = ты) обычно опускаются, поскольку суффикс глагола уже указывает на деятеля.",
      "Турецкий фонетически регулярен — каждая буква всегда произносится одинаково. Что читаешь, то и говоришь.",
      "Отрицание образуется добавлением -me/-ma прямо к корню глагола: gel (приходи) → gelme (не приходи), anla (понимай) → anlama.",
      "Турецкий использует послелоги, которые стоят ПОСЛЕ существительного: «İstanbul'da» = «в Стамбуле» (Стамбул + суффикс места -da).",
      "Суффикс множественного числа следует гармонии гласных: -lar после задних гласных (a, ı, o, u) и -ler после передних (e, i, ö, ü).",
      "Суффикс -ıyor/-iyor/-uyor/-üyor обозначает настоящее длительное время. Anlıyorum = Я понимаю (anla + ıyor + um).",
      "Сложные турецкие глаголы сочетают существительное с etmek (делать) или olmak (быть): teşekkür etmek (благодарить), hazır olmak (быть готовым).",
    ],
  },
  lesson: {
    backBtn: "← Назад",
    topicOf: "Тема {order} из {total} · {words} слов",
    translating: "Подготовка урока…",
    newWords: "✨ Новые слова ({n})",
    alreadyLearned: "🔄 Уже изучено ({n})",
    practiceDialogue: "🎭 Практика",
    generateDialogue: "🎭 Дай мне диалог для практики",
    listenSpeakPractice: "🎧 Практика в Лаборатории «Слушай и говори»",
    generatingDialogue: "Баби готовит ваш диалог…",
    newDialogue: "↺ Новый диалог",
    lessonSaved: "🎉 Урок сохранён! Добавляется {n} новых карточек…",
    alreadyTaken: "✅ Урок уже пройден",
    markComplete: "✅ Завершить урок и сохранить карточки",
  },
  vocab: {
    structure: "Структура",
    loadingExample: "Загрузка…",
    limitReached: "↺ Лимит достигнут",
    anotherLeft: "↺ Ещё ({n} осталось)",
    anotherExample: "↺ Другой пример",
    analyzing: "Анализ…",
    analyzed: "✓ Проанализировано",
    analyzeWord: "🔍 Разобрать слово",
    analysisIntro: "Вот пошаговый грамматический анализ:",
    analysisError: "Не удалось загрузить анализ. Попробуйте снова.",
    reportMistake: "🚩 Сообщить об ошибке",
    reportWrongMeaning: "Неверное значение слова",
    reportWrongSentence: "Неверный перевод предложения",
    reportOther: "Другое",
    reportChecking: "Проверяется…",
    reportThanks: "✓ Спасибо, что помогаете нам улучшаться!",
    reportNoIssue: [
      "Я не нашёл здесь никакой проблемы — мне кажется, это правильно!",
      "Я не вижу здесь никаких проблем — это выглядит правильно.",
      "На мой взгляд, всё в порядке.",
      "Я не смог найти никаких проблем; это выглядит правильно, как написано.",
      "Мне это кажется хорошим — у меня нет замечаний.",
      "Я проверил и не нашёл ничего, что нужно было бы изменить.",
      "Я не заметил никаких проблем; перевод выглядит правильным.",
      "Насколько я могу судить, всё верно.",
      "Мне не удалось обнаружить никаких проблем; это выглядит нормально.",
    ],
    reportCheckError: "Не удалось завершить проверку. Пожалуйста, попробуйте позже.",
    reportOkBtn: "Хорошо, понятно",
    reportEscalateBtn: "Передать живому модератору",
    reportEscalatedMsg: "✓ Отправлено нашей команде проверки. Спасибо!",
    reportAlreadyFlaggedMsg: "✓ Это уже было передано нашей команде проверки. Спасибо!",
  },
  allLessons: {
    title: "📚 Все уроки",
    subtitle: "{count} тем · {words} слов",
    searchPlaceholder: "🔍 Поиск тем или слов…",
    noResults: "Нет тем, соответствующих \"{search}\"",
    overwhelmedBanner: "У вас {n} карточек для повтора. Пожалуйста, повторите карточки перед началом новых уроков.",
    overwhelmedLock: "Сначала повторите карточки",
    overwhelmedBtn: "Перейти к карточкам →",
  },
  flashcards: {
    title: "Карточки",
    cardOf: "Карточка {current} из {total}",
    tapToReveal: "Нажмите для показа",
    hearIt: "🔊 Послушать",
    hearSentence: "🔊 Послушать предложение.",
    allConsolidated: "Всё закреплено",
    noDue: "Нет карточек для повторения.\nВаша память хорошо отдохнула.",
    backToDashboard: "Вернуться на главную",
    sessionComplete: "Сессия завершена",
    memoryRetention: "Эффективность памяти",
    forgotten: "Забыл",
    struggled: "Трудно",
    recalled: "Вспомнил",
    effortless: "Легко",
    wordsConsolidated: "{retained} из {total} слов закреплено",
    wordsInProgress: "{retained} из {total} слов в процессе",
    saveContinue: "Сохранить и продолжить",
    tomorrow: "Завтра",
    nDays: "{n} дн.",
    d1Title: "Понимание",
    d1SubSkill: "Для улучшения навыков чтения и аудирования",
    d1Journey: "Новые слова начинают свой путь здесь.",
    d1Due: "{n} на повтор",
    d1Listen: "Послушать",
    d1ShowWord: "Показать слово",
    d2Title: "Производство",
    d2SubSkill: "Для улучшения навыков речи и письма",
    d2WillStart: "Начнётся позже",
    d2Empty: "Слова попадают сюда после усвоения в наборе карточек для понимания.",
    d2ModalTitle: "Практика производства открыта!",
    d2ModalBody: "Это слова, которые вы уже хорошо узнаёте. Теперь мы тренируем вас их воспроизводить — так вы переходите от понимания {targetLang} к его использованию.",
    d2ModalBtn: "Понятно",
    leaveConfirmTitle: "Несохранённый прогресс повторения",
    leaveConfirmBody: "Вы повторили карточки в этой сессии, которые ещё не сохранены. Если вы выйдете сейчас без сохранения, этот прогресс будет потерян.",
    leaveConfirmSave: "Сохранить и выйти",
    leaveConfirmDiscard: "Выйти без сохранения",
    leaveConfirmCancel: "Отмена",
    faq: {
      whyTwoQ: "Зачем две колоды?",
      whyLaterQ: "Почему Колода 2 начинается позже?",
      whyReturnQ: "Почему карточки возвращаются?",
    },
  },
  grammarLab: {
    title: "📘 Лаборатория грамматики",
    subtitle: "{count} тем по грамматике для изучения",
    backBtn: "← Назад",
    searchPlaceholder: "🔍 Поиск тем по грамматике…",
    noResults: "Нет тем по грамматике, соответствующих \"{search}\"",
    allCategories: "Все категории",
    allLevels: "Все уровни",
    notReviewedLabel: "Не изучено",
    reviewedLabel: "Изучено",
    dueBadge: "{n} на повторение",
    explanationLabel: "Объяснение",
    seeReference: "(см. {term})",
    ruleLabel: "Правило",
    formsLabel: "Формы",
    translatingNote: "Идёт перевод на русский...",
    practiceBtn: "▶ Практиковать эту тему",
    detailedExplanationBtn: "📖 Подробное объяснение",
    practiceTitle: "Практика",
    practiceQuestion: "Как это сказать по-турецки?",
    practiceOf: "{current} из {total}",
    practiceCorrectFeedback: "Верно!",
    practiceIncorrectFeedback: "Не совсем — правильный ответ: {answer}.",
    practiceNext: "Далее →",
    practiceDone: "Практика завершена",
    practiceScore: "{correct} из {total} правильно",
    practiceNextReview: "Следующее повторение через {days} дн.",
    practiceReset: "На этот раз не получилось — вы снова увидите эту тему завтра.",
    practiceAgainBtn: "Практиковать снова",
    practiceCloseBtn: "Готово",
    categories: {
      existential: "Бытийность",
      noun_suffix: "Суффикс существительного",
      case_suffix: "Падежный суффикс",
      verb_conjugation: "Спряжение глагола",
      question_particle: "Вопросительная частица",
      copula: "Связка",
      modal_construction: "Модальная конструкция",
    },
    points: {
      GP0001: { title: "Существование и наличие: var / yok", ruleSummary: "[место/обладатель] + [предмет] + var / yok" },
      GP0002: { title: "Суффикс множественного числа: -ler / -lar", ruleSummary: "существительное + -ler (передний ряд) / -lar (задний ряд)" },
      GP0003: { title: "Местный падеж: -de / -da / -te / -ta", ruleSummary: "существительное + -de/-da; -te/-ta после глухого согласного" },
      GP0004: { title: "Дательный падеж: -e / -a", ruleSummary: "существительное + -e/-a; после гласной вставляется соединительная -y-" },
      GP0005: { title: "Исходный падеж: -den / -dan / -ten / -tan", ruleSummary: "существительное + -den/-dan; -ten/-tan после глухого согласного" },
      GP0006: { title: "Винительный падеж: -i / -ı / -u / -ü (определённое прямое дополнение)", ruleSummary: "существительное + -i/-ı/-u/-ü; соединительная -y- после гласной" },
      GP0007: { title: "Настоящее продолженное — утвердительная форма: -iyor", ruleSummary: "основа глагола + -iyor + личное окончание" },
      GP0008: { title: "Настоящее продолженное — отрицательная форма: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "основа глагола + -mıyor/-miyor/-muyor/-müyor + личное окончание" },
      GP0009: { title: "Настоящее продолженное — вопросительная форма: -iyor mu", ruleSummary: "основа + -iyor + mu(+личное); onlar: основа + -iyorlar + mı" },
      GP0010: { title: "Вопросительная частица да/нет: mı / mi / mu / mü", ruleSummary: "[слово] + отдельно пишущаяся частица mı/mi/mu/mü ?" },
      GP0011: { title: "Простое прошедшее время: -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "основа глагола + -di/-dı/-du/-dü (или -ti/... после глухого) + личное окончание" },
      GP0012: { title: "Окончания глагола-связки (наст. время): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "сказуемое + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "Притяжательные суффиксы: мой / твой / его-её / наш / ваш / их", ruleSummary: "(benim/senin/...) существительное + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "Выражение желания: -mek / -mak istemek", ruleSummary: "[инфинитив -mek/-mak] + istemek (спрягаемый)" },
      GP0015: { title: "Вежливая просьба / повелительное наклонение 2 л. мн. ч.: -in / -iniz", ruleSummary: "основа глагола + -in/-ın/-un/-ün (вежливо) или -iniz (более формально); соединительная -y- после гласной" },
    },
  },
  placementTest: {
    title: "🎯 Тест на уровень",
    offerTitle: "Уже немного знаете турецкий?",
    offerBody: "Пройдите короткий тест на уровень — около 20 вопросов — чтобы определить стартовый уровень. Мы настроим ваш текущий урок соответственно, но все темы останутся доступны для просмотра.",
    startBtn: "Начать тест",
    notNowBtn: "Не сейчас",
    roundLabel: "Раунд {round} из {totalRounds}",
    questionLabel: "Вопрос {n} из {total}",
    wordPrompt: "Что означает это слово?",
    listeningPrompt: "Послушайте и выберите слово, которое вы услышали",
    listeningReplay: "Прослушать снова",
    preparingRound: "Готовим ваши вопросы…",
    finishBtn: "Посмотреть результат",
    resultsTitle: "Ваш результат теста",
    resultsLevel: "Вы определены на уровень {level}",
    resultsBody: "Ваш текущий урок теперь начинается с этого уровня. Вы всегда можете просмотреть любую предыдущую или следующую тему в разделе «Все уроки».",
    continueBtn: "Продолжить",
  },
  goals: {
    title: "🎯 Мои цели",
    displayName: "Отображаемое имя",
    namePlaceholder: "Ваше имя…",
    vocabTarget: "Цель по словарю",
    words: "слов",
    minWords: "1 500 мин",
    midWords: "2 000",
    maxWords: "3 500 макс",
    courseDuration: "Целевая продолжительность курса",
    months: "Месяцев",
    month: "месяц",
    monthsPlural: "месяцев",
    daysSummary: "= {days} дней",
    baseLanguage: "Базовый язык",
    otherLanguage: "Другие языки (скоро)",
    selectLanguage: "Выберите язык…",
    ok: "OK",
    langNames: {
      English: "Английский", Farsi: "Персидский", Arabic: "Арабский",
      French: "Французский", German: "Немецкий", Spanish: "Испанский",
      Russian: "Русский", Portuguese: "Португальский", Chinese: "Китайский",
      Turkish: "Турецкий", Hindi: "Хинди", Italian: "Итальянский",
    },
    targetLanguage: "Целевой язык",
    targetLangNames: {
      Turkish: "Турецкий",
    },
    wordsLbl: "слов",
    wordsPerDay: "слов/день",
    daysLbl: "дней",
    saved: "✅ Цели сохранены!",
  },
  progress: {
    title: "📈 Мой прогресс",
    memDistTitle: "Распределение состояний памяти · {n} карточек",
    inAcquisition: "В изучении",
    rooted: "Закреплено",
    fluent: "Свободно",
    deeplyRetained: "Глубоко усвоено",
    acqDesc: "стабильность < 3 дней",
    rootedDesc: "стабильность 3–21 день",
    fluentDesc: "стабильность 21–90 дней",
    retainedDesc: "стабильность 90+ дней",
    forecastTitle: "Прогноз повторений — следующие 15 дней",
    cardsDue: "Карточек к повторению",
    today: "Сегодня",
    tmrw: "Завтра",
    plusDays: "+{n}д",
    todayFull: "Сегодня",
    tmrwFull: "Завтра",
    plusDaysFull: "+{n} дней",
    goalProgress: "Общий прогресс к цели",
    wordsLearned: "{learned} / {target} слов изучено",
    vocabGrowth: "Рост словарного запаса",
    noChart: "Завершите первый урок, чтобы увидеть график! 📚",
    wordsLearnedSeries: "Изученные слова",
    topicRings: "Кольца памяти по темам",
    quickStats: "Быстрая статистика",
    dayStreak: "дней подряд 🔥",
    lessonsDone: "уроков пройдено",
    totalStudy: "всего обучения",
    avg14Day: "среднее за 14д",
    minUnit: "мин",
    dayLabel: "День {n}",
    cards: "карточек",
  },
  myVocab: {
    title: "📝 Мой словарь",
    summaryTitle: "{n} изученных слов",
    searchPlaceholder: "🔍 Поиск по вашим словам…",
    allStatuses: "Все статусы",
    noResults: "Нет слов, соответствующих \"{search}\"",
    noWords: "Завершите урок, чтобы начать пополнять словарь! 📚",
    completedTopicsTitle: "Завершённые темы ({n} из {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Новичок",
    wordExplorer: "Исследователь Слов",
    wordNerd: "Ботан по Словам",
    wordWizard: "Маг Слов",
    rockstar: "Рок-звезда",
    expert: "Эксперт",
    champion: "Чемпион",
  },
  memStates: {
    inAcquisition: "В изучении",
    rooted: "Закреплено",
    fluent: "Свободно",
    deeplyRetained: "Глубоко усвоено",
  },
  chat: {
    subtitle: "Ваш репетитор турецкого",
    greetWords: ["Привет", "Здравствуй", "Приветствую"],
    greeting: "{greet} {name},\n\nСпрашивайте меня о турецком — грамматика, словарный запас, культура — или о том, как пользоваться приложением.",
    placeholder: "Вопрос о турецком или приложении…",
    error: "Извините, не удалось подключиться. Попробуйте снова.",
    escalationFallback: "Извините, я не смог полностью помочь с этим. Я передал это нашей команде, и вы получите ответ по электронной почте — обычно в течение 2 рабочих дней. Вы также можете написать нам напрямую на support@speafy.com.",
    welcome: "Привет, {name}! 👋 Добро пожаловать в Speafy! Я Баби, и я здесь для двух вещей: помочь вам разобраться в приложении и ответить на любые вопросы о {targetLanguage}.\n\nНачните с текущего урока или выберите тему из раздела «Все уроки». Не забывайте отмечать каждый урок как завершённый, когда закончите, а затем повторяйте карточки.\n\nСпрашивайте меня в любое время — о приложении или о {targetLanguage}.\n\nУдачи в вашем учебном путешествии! 😊",
    lessonLimit: "Вы уже завершили {limit} урока сегодня — отличная работа! 🌟\n\nЧтобы обучение оставалось устойчивым и не перегружать очередь карточек, установлен дневной лимит в {limit} урока.\n\nДайте мозгу время закрепить пройденное сегодня. Как насчёт сессии повторения карточек вместо этого?\n\nДо завтра — продолжим! 😊",
    streakDecayed: "С возвращением! 👋 Вас не было {days} дн. Благодаря {protection} дням защиты серии 🛡️, которые вы заработали, ваша серия снизилась только с {oldStreak} до {newStreak}, вместо того чтобы исчезнуть полностью. Продолжим строить дальше!",
    streakWiped: "С возвращением! 👋 Вас не было {days} дн. — это больше, чем {protection} дней защиты серии 🛡️, которые у вас были накоплены, поэтому серия началась заново с 1. Любая серия с чего-то начинается — давайте отстроим её заново!",
    weeklyRecapFallback: "Привет! 👋 Я хотел показать вам ваш еженедельный обзор, но сейчас у меня проблемы с его подготовкой. Но быстро отмечу — у вас серия в {streak} дн., продолжайте в том же духе! 🔥",
    dailyPlanQuestion1: "Привет! 👋 Сколько времени у вас есть на учёбу сегодня?",
    dailyPlanQuestion2: "Здравствуйте! 😊 У меня есть план занятий для вас — сколько минут вы можете уделить сегодня?",
    dailyPlanQuestion3: "Готовы к плану на сегодня? 🎯 Просто скажите примерно, сколько у вас есть времени.",
    dailyPlanClarify: "Извините, я не совсем понял! Не могли бы вы назвать примерное число, например '20' или '30 минут'?",
    dailyPlanUnreasonable: "Это не похоже на обычную учебную сессию! Не могли бы вы назвать что-то между 5 минутами и примерно 5 часами?",
    dailyPlanGiveUp: "Ничего страшного — когда будете готовы, просто перейдите к карточкам или текущему уроку и начните! 😊",
    dailyPlanFallback: "Я записал ваше доступное время, но сейчас у меня проблемы с составлением плана на сегодня. А пока карточки — всегда надёжный вариант, если у вас есть карточки к повторению! 😊",
    sendBtn: "Отправить",
    askBabi: "Спросить Баби",
    voiceConsentTitle: "Включить голосовой чат с Баби?",
    voiceConsentBody: "Баби будет использовать ваш микрофон, чтобы слышать вас, и динамик, чтобы отвечать вам. Ваша речь преобразуется в текст — сама аудиозапись никогда не сохраняется. Текст может храниться до 30 дней. Подробности см. в нашей Политике конфиденциальности.",
    voiceConsentPrivacyLink: "Политика конфиденциальности",
    voiceConsentAllow: "Разрешить микрофон",
    voiceConsentDecline: "Не сейчас",
    voiceDenied: "Голосовой чат недоступен без доступа к микрофону. Вы можете продолжать общаться текстом — нажмите на значок микрофона в любое время, чтобы попробовать снова.",
    voiceDeviceInUse: "Похоже, ваш микрофон используется в другом месте — закройте другие приложения, использующие его, и попробуйте снова.",
    voiceError: "Что-то пошло не так с голосовым чатом. Попробуйте снова.",
    voiceStarting: "Запуск… подождите",
    voiceListening: "Слушаю…",
    voiceProcessing: "Понимаю…",
    voiceReviewHint: "Нажмите, чтобы изменить, иначе это будет отправлено автоматически через несколько секунд.",
    voiceSendNow: "Отправить сейчас",
    voiceDiscard: "Отменить",
    voiceEditTranscript: "Изменить то, что услышала Баби",
    voiceBadgeLabel: "Отправлено голосом",
    voiceDidntCatch: "Не расслышала — нажмите на микрофон, чтобы попробовать снова.",
    voiceSpeaking: "Баби говорит…",
    voiceTtsUnavailable: "Аудио для этого ответа недоступно — вместо этого показан текст.",
    voiceTtsUnavailableLanguage: "Голосовой ответ Баби пока недоступен на {language}.",
    voiceTapToHear: "Нажмите, чтобы услышать ответ Баби",
    voiceNotEntitled: "Голосовой чат с Баби — премиум-функция, оформите подписку, чтобы её использовать.",
    voiceNoBalance: "Вы использовали все голосовые минуты за этот цикл. Они обновятся в следующем цикле.",
    voiceOtherTabActive: "Голосовой чат уже активен в другой вкладке.",
    voiceLowBalanceNudge: "Голосовые минуты за этот цикл почти закончились.",
    voiceLowMinutesHeadsUp: "Голосовые минуты за этот цикл почти закончились.",
    voiceGetMoreMinutes: "Получить больше минут",
    voiceStopBtn: "Стоп",
    voiceMicButtonLabel: "Голосовой чат",
    voiceBannerDismiss: "Закрыть",
  },
  settings: {
    title: "Настройки",
    accountSection: "Аккаунт",
    linkedGoogle: "Привязан к Google",
    emailAccountBadge: "Аккаунт с email",
    changeNameBtn: "Изменить имя пользователя",
    nameSaveBtn: "Сохранить",
    nameCancelBtn: "Отмена",
    nameSaving: "Сохранение…",
    passwordLabel: "Пароль",
    passwordSub: "Отправить ссылку для сброса на вашу почту",
    passwordSent: "Отправлено ✓",
    passwordResetBtn: "Сбросить",
    subscriptionSection: "Подписка",
    subscriptionAdminLabel: "Аккаунт администратора",
    subscriptionAdminSub: "У вас есть полный, постоянный доступ ко всем функциям.",
    subscriptionReviewerLabel: "Доступ рецензента",
    subscriptionReviewerSub: "У вас есть бесплатный доступ ко всем функциям как у рецензента приложения.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Годовая",
    subscriptionPlanMonthly: "Месячная",
    subscriptionRenews: "Продление {date}",
    subscriptionActive: "Активна",
    subscriptionManageLink: "Платежи и счета",
    subscriptionCancelLink: "Отменить или приостановить подписку",
    subscriptionPaymentFailedLabel: "Последний платёж не прошёл",
    subscriptionPaymentFailedSub: "Платёж не прошёл {date}",
    subscriptionPaymentFailedSubNoDate: "Пожалуйста, обновите способ оплаты, чтобы сохранить доступ к Pro",
    subscriptionUpdatePaymentLink: "Обновить способ оплаты ↗",
    subscriptionCancelledPending: "Ваш план заканчивается {date} — до этого момента у вас сохранится доступ к Pro",
    subscriptionPausedLabel: "Подписка приостановлена",
    subscriptionPausedSub: "Автоматически возобновится {date} — будет списана полная стоимость нового периода, если вы не возобновите раньше",
    subscriptionPausedSubNoDate: "Автоматически возобновится через 3 месяца, если вы не возобновите раньше",
    subscriptionResumeBtn: "Возобновить сейчас",
    subscriptionResuming: "Возобновление…",
    pausePendingLabel: "Приостановка запланирована",
    pausePendingSub: "Вступит в силу {date}, в конце текущего расчётного периода",
    manageOfferTitle: "Думаете отменить подписку?",
    manageOfferSub: "Приостановите вместо этого — вы сохраните свой прогресс до {date}, а затем подписка автоматически возобновится через 3 месяца, и будет списана полная стоимость нового периода, если вы не возобновите раньше.",
    manageOfferPauseBtn: "Приостановить вместо этого",
    manageOfferContinueLink: "Всё равно отменить",
    manageOfferDismiss: "Не нужно",
    pauseOfferLabel: "Нужен перерыв?",
    pauseOfferSub: "Приостановите подписку на 3 месяца вместо отмены — сохраните свой прогресс и возобновите в любое время.",
    pauseOfferBtn: "Приостановить подписку",
    pauseConfirmP1: "Приостановить вашу подписку Speafy Pro?",
    pauseConfirmC1: "Текущий расчётный период продолжается до {date} — вы сохраняете всё, за что уже заплатили.",
    pauseConfirmC2: "Во время приостановки новые Уроки заблокированы (как при истёкшем бесплатном плане), но вы можете продолжать повторять свои Карточки в обычном режиме.",
    pauseConfirmC3: "Приостановка длится ровно 3 месяца. Если вы не возобновите её вручную до этого срока, подписка возобновится автоматически, и будет списана полная стоимость нового периода.",
    pauseConfirmBtn: "Подтвердить приостановку",
    pausing: "Приостановка…",
    pauseFailedGeneric: "Что-то пошло не так при приостановке подписки. Попробуйте снова или обратитесь в поддержку.",
    manageLinkLoading: "Загрузка…",
    manageLinkFailedGeneric: "Не удалось загрузить ссылку для управления. Попробуйте снова.",
    resumeConfirmP1: "Возобновить вашу подписку Speafy Pro прямо сейчас?",
    resumeConfirmC1: "С вас сразу же будет списана полная стоимость нового расчётного периода.",
    resumeConfirmBtn: "Да, возобновить сейчас",
    resumeFailedGeneric: "Что-то пошло не так при возобновлении подписки. Попробуйте снова или обратитесь в поддержку.",
    subscriptionLastCharge: "Последний платёж: {amount} {date} — {status}",
    subscriptionLastChargePaid: "Оплачено",
    subscriptionLastChargeFailed: "Не прошёл",
    tierChangePendingLabel: "Смена плана запланирована",
    tierChangePendingToElite: "Переход на Elite {date}",
    tierChangePendingToBasic: "Переход на Pro {date}, в конце текущего расчётного периода",
    tierUpgradeToEliteLink: "Перейти на Elite",
    tierDowngradeToBasicLink: "Вернуться на Pro",
    tierUpgradeConfirmTitle: "Перейти на Elite?",
    tierUpgradeConfirmSub: "Сегодня с вас спишут пропорциональную разницу, и вы сразу получите 3 часа голосового общения Elite с Баби — далее {price}/{interval}.",
    tierDowngradeConfirmTitle: "Вернуться на Pro?",
    tierDowngradeConfirmSub: "Вы сохраните Elite до {date}, затем перейдёте на Pro в следующую дату списания — сегодня платы не будет.",
    tierUpgradeConfirmBtn: "Да, перейти сейчас",
    tierDowngradeConfirmBtn: "Да, вернуться на Pro",
    tierChangeBusy: "Обновление…",
    tierChangeFailedGeneric: "Не удалось изменить ваш план. Попробуйте ещё раз или обратитесь в поддержку.",
    voiceMinutesLabel: "Голосовые минуты ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Пробный период",
    voiceTierAdmin: "Админ",
    voiceTierViewer: "Наблюдатель",
    voiceMinutesUsed: "Использовано {used} из {limit} за этот цикл",
    voiceMinutesPurchasedExtra: "Плюс {extra} купленных — расходуются после месячных минут и никогда не сгорают",
    yourDataSection: "Ваши данные",
    marketingLabel: "Согласие на маркетинговые рассылки",
    marketingSub: "Обновления, уведомления и специальные предложения",
    voiceConsentLabel: "Голосовой чат с Баби",
    voiceConsentSub: "Разрешить Баби слышать вас и отвечать вслух",
    privacyLegalSection: "Конфиденциальность, условия и правовая информация",
    privacyPolicyLabel: "Политика конфиденциальности",
    privacyPolicySub: "Как мы собираем, используем и защищаем ваши данные",
    viewLink: "Просмотреть",
    termsLabel: "Условия использования",
    termsSub: "Правила и условия, регулирующие использование",
    refundLabel: "Политика возврата средств",
    refundSub: "Право на возврат и порядок оформления",
    cookieSettingsLabel: "Настройки cookie",
    cookieSettingsSub: "Управление аналитическими и функциональными cookie",
    manageLink: "Управление",
    privacySection: "Конфиденциальность и данные",
    exportLabel: "Экспортировать мои данные",
    exportSub: "Скачать JSON-файл с профилем, прогрессом и карточками",
    exportBtn: "Экспорт",
    exportDone: "✓ Скачано",
    cacheLabel: "Локальный кэш",
    cacheSub: "Прогресс обучения и примеры предложений кэшируются в браузере для скорости.",
    cookieLabel: "Настройки cookies и конфиденциальности",
    cookieSub: "Аналитика и настройки cookies управляются на сайте Speafy",
    privacyLink: "Политика конфиденциальности ↗",
    aboutSection: "О приложении",
    aiTutorLabel: "ИИ-репетитор",
    aiTutorSub: "На базе Claude Sonnet — Anthropic",
    algoLabel: "Алгоритм памяти",
    algoSub: "FSRS v4.5 — Планировщик интервального повторения",
    learningSection: "Обучение",
    placementTestLabel: "Тест на уровень",
    placementTestSubNew: "Узнайте свой стартовый уровень с помощью короткого теста",
    placementTestSubRetake: "Последний результат: {level} · можно пройти повторно в любое время",
    placementTestBtnNew: "Пройти тест",
    placementTestBtnRetake: "Пройти повторно",
    versionLabel: "Версия",
    appearanceSection: "Внешний вид",
    darkModeLabel: "Тёмная тема",
    darkModeSub: "Переключиться на тёмную цветовую схему",
    largeTextLabel: "Крупный текст",
    largeTextSub: "Увеличивает размер текста для удобного чтения",
    babiCheckinsSection: "Проверки от Баби",
    babiDailyNudgeLabel: "Ежедневное напоминание от Баби",
    babiDailyNudgeSub: "Баби спрашивает, сколько у вас времени, и предлагает план занятий каждый день",
    babiWeeklyReportLabel: "Еженедельный отчёт от Баби",
    babiWeeklyReportSub: "Еженедельный обзор вашего прогресса, раз в неделю",
    dangerSection: "Опасная зона",
    resetLabel: "Сбросить весь прогресс",
    resetSub: "Удаляет вашу серию, карточки и историю уроков. Отменить невозможно.",
    resetBtn: "Сбросить",
    resetConfirmP1: "Сбросить весь прогресс? Это безвозвратно удалит:",
    resetConfirmC1: "Все {n} карточек и их данные памяти",
    resetConfirmC2: "Вашу серию ({n} дней) и историю занятий",
    resetConfirmC3: "Все записи о пройденных уроках на каждом изучаемом вами языке",
    resetConfirmC4: "Ваш прогресс повторения в Лаборатории грамматики",
    resetConfirmP2: "Аккаунт, имя и настройки языка сохранятся.",
    resetConfirmBtn: "Да, сбросить всё",
    resetting: "Сброс…",
    resetDone: "✅ Прогресс сброшен! Вы начинаете заново.",
    deleteLabel: "Удалить аккаунт",
    deleteSub: "Навсегда удаляет аккаунт и все данные. Отменить невозможно.",
    deleteBtn: "Удалить аккаунт",
    deleteConfirmP1: "Навсегда удалить аккаунт Speafy? Это немедленно и безвозвратно удалит:",
    deleteConfirmC1: "Ваш профиль (имя, язык, цели)",
    deleteConfirmC2: "Все {n} карточек и данные памяти",
    deleteConfirmC3: "Полную историю обучения и серию",
    deleteConfirmC4: "Ваш аккаунт аутентификации Firebase",
    deleteConfirmPrompt: "Введите DELETE (заглавными буквами) для подтверждения:",
    deleteConfirmBtn: "Безвозвратно удалить мой аккаунт",
    deleting: "Удаление…",
    cancelBtn: "Отмена",
  },
  trial: {
    daysLeftBadge: "⏱ {n} дн. осталось",
    expiredBadge: "Пробный период истёк · Обновить ↑",
    pausedBadge: "⏸ Приостановлено",
    proBadge: "✦ Pro-план",
    eliteBadge: "✦ Elite-план",
  },
  paywall: {
    back: "← Назад",
    title: "Обновить до Speafy Pro",
    subTrialExpired: "Ваш бесплатный пробный период истёк. Обновите, чтобы продолжить обучение.",
    subDefault: "Разблокируйте все уроки и повторение карточек.",
    features: [
      "Все {count} уроков полностью разблокированы",
      "Неограниченный чат с Баби, AI-репетитором",
      "Умное повторение FSRS",
      "Отслеживание прогресса и аналитика памяти",
      "Нативное аудио для каждого слова",
      "Практические диалоги",
      "Многоязычный интерфейс",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Всё, что есть в Speafy Pro",
      "Лаборатория «Слушай и говори» — практика разговора с Баби",
      "3 часа голосового общения с Баби каждый месяц",
      "Покупайте дополнительные голосовые минуты в любое время — $3/час",
    ],
    billingMonthly: "Ежемесячно",
    billingYearly: "Ежегодно",
    saveBadge: "Скидка 25%",
    pricePerMonth: "/мес.",
    priceBilledYearly: "оплата раз в год",
    cta: "Начать Speafy Pro →",
    ctaElite: "Начать Speafy Elite →",
    fine: "Отмена в любое время · Безопасная оплата через Paddle",
    bannerExpired: "Ваш бесплатный пробный период истёк.",
    bannerActive: "Пробный период — осталось {n} дн.",
    bannerBtn: "Обновить ↑",
    settingsFreePlan: "Бесплатный план",
    pausedTitle: "Ваша подписка приостановлена",
    pausedSub: "Возобновите подписку в Настройках, чтобы снова разблокировать новые уроки.",
    pausedGoToSettingsBtn: "Перейти в Настройки",
    alreadyProTitle: "У вас уже есть Pro!",
    alreadyProSub: "Ваша подписка активна — повторная покупка не требуется.",
    alreadyProGoHomeBtn: "На главную",
    settingsTrialRemaining: "Пробный период — осталось {n} дн.",
    settingsTrialEnded: "Пробный период истёк — обновите для доступа ко всем урокам",
    settingsFreeForever: "Продолжите с того места, где остановились — обновите, чтобы открыть все уроки",
    settingsUpgradeBtn: "Обновить",
  },
  authAction: {
    verifyingTitle: "Проверяем ваш email…",
    verifiedTitle: "Ваш email подтверждён!",
    verifiedBody: "Всё готово. Вернитесь в Speafy, чтобы продолжить обучение.",
    continueBtn: "Продолжить в Speafy →",
    verifyErrorTitle: "Срок действия ссылки истёк",
    verifyErrorBody: "Эта ссылка для подтверждения больше не действительна. Войдите, и мы отправим вам новую.",
    resendBtn: "Отправить письмо повторно",
    resendSent: "Отправлено ✓",
    resendError: "Не удалось отправить повторно. Попробуйте ещё раз через минуту.",
    signInBtn: "Войти",
    verifyingReset: "Проверяем вашу ссылку…",
    resetTitle: "Сбросьте пароль",
    resetBodyFor: "Выберите новый пароль для {email}",
    newPasswordPh: "Новый пароль",
    confirmPasswordPh: "Подтвердите новый пароль",
    resetSubmitBtn: "Сбросить пароль",
    resettingBtn: "Сброс…",
    resetSuccessTitle: "Пароль обновлён!",
    resetSuccessBody: "Ваш пароль был изменён. Войдите с новым паролем.",
    resetErrorTitle: "Срок действия ссылки истёк",
    resetErrorBody: "Эта ссылка для сброса пароля больше не действительна. Запросите новую на экране входа.",
    passwordMismatch: "Пароли не совпадают.",
    passwordTooShort: "Пароль должен содержать не менее 6 символов.",
    genericError: "Что-то пошло не так. Попробуйте ещё раз.",
    invalidTitle: "Эта ссылка недействительна или срок её действия истёк",
    invalidBody: "Ссылка, по которой вы перешли, больше не действительна. Вернитесь в Speafy и попробуйте снова.",
    backToSignIn: "Вернуться ко входу",
  },

  teacherDash: {
    link: "Панель преподавателя",
    title: "Панель преподавателя",
    backHome: "На главную",
    studentBadge: "Ваш преподаватель: {name}",
    intro: "Всё необходимое, чтобы привести учеников в Speafy и следить за их прогрессом.",
    referralTitle: "Ваша реферальная ссылка",
    referralBody: "Поделитесь этой ссылкой с учениками. Каждый, кто зарегистрируется по ней, будет закреплён за вами как за преподавателем.",
    copy: "Скопировать ссылку",
    copied: "Скопировано",
    studentsTitle: "Ваши ученики",
    studentsLoading: "Загрузка ваших учеников…",
    studentsError: "Не удалось загрузить ваших учеников прямо сейчас.",
    retry: "Повторить",
    studentsEmpty: "Учеников пока нет. Поделитесь своей реферальной ссылкой — ученики, присоединившиеся по ней, появятся здесь.",
    colName: "Ученик",
    colJoined: "Присоединился",
    colStatus: "Подписка",
    colCommission: "Начисленная комиссия",
    colGrammar: "Грамматический фокус",
    statusActive: "Активна",
    statusTrial: "Пробный период",
    statusNone: "Без подписки",
    commissionNote: "Это то, что вы заработали с каждого студента в общей сложности. Ваш доступный для выплаты баланс показан ниже.",
    commissionCapReached: "12-месячный период завершён",
    grammarNote: "Данные об ошибках в грамматике показываются только для учеников с активной подпиской.",
    studentUnnamed: "Ученик",
    curriculumTitle: "Справочник по программе",
    curriculumBody: "Просмотрите все темы и слова, которые изучают ваши ученики, по порядку.",
    curriculumLink: "Открыть справочник по программе",
    profileTitle: "Ваш профиль преподавателя",
    profileBody: "Так вы будете выглядеть в каталоге преподавателей Speafy после его запуска.",
    profileBio: "Краткое описание",
    profileBioPh: "Пара предложений о вас и о том, как вы преподаёте.",
    profilePhoto: "Фото",
    photoChoose: "Выбрать фото",
    photoUploading: "Загрузка…",
    photoRemove: "Удалить",
    photoHint: "PNG или JPG, до 200 КБ.",
    photoTypeErr: "Выберите изображение в формате PNG или JPG.",
    photoSizeErr: "Это изображение больше 200 КБ — выберите поменьше.",
    photoUploadErr: "Не удалось загрузить. Попробуйте ещё раз.",
    profileLink: "Личный сайт или ссылка на соцсеть",
    profileLinkPh: "www.example.com",
    profileLanguages: "Языки, которые я преподаю",
    profileLanguagesHint: "Выберите языки, которые вы преподаёте. Новые варианты появятся, когда Speafy добавит их как языки курса.",
    profileLanguagesSoon: "Скоро",
    save: "Сохранить",
    saving: "Сохранение…",
    saved: "Сохранено",
    urlError: "Это не похоже на веб-адрес. Проверьте его или оставьте поле пустым.",
    termsStatusAccepted: "Условия партнёрства для преподавателей — приняты {date}",
    termsStatusPending: "Условия партнёрства для преподавателей — ещё не приняты",
    termsVersionLabel: "Версия {version}",
    termsView: "Посмотреть принятые условия",
    payoutTitle: "Выплата",
    payoutLoading: "Загружаем статус вашей выплаты…",
    payoutError: "Не удалось загрузить статус вашей выплаты.",
    payoutBalance: "Ваш текущий баланс: {balance}",
    payoutNotEligible: "Вы сможете запросить выплату, когда ваш баланс достигнет {threshold}.",
    payoutAlreadyRequested: "Выплата запрошена — мы свяжемся с вами.",
    requestPayoutBtn: "Запросить выплату",
    payoutRequestFailed: "При отправке запроса произошла ошибка. Попробуйте ещё раз.",
    payoutConfirmTitle: "Запросить выплату?",
    payoutConfirmBody: "Сейчас у вас есть {balance}, доступные для запроса.\n\nЭто запускает ручной процесс выплаты — деньги не переводятся автоматически. Мы рассмотрим ваш запрос и свяжемся с вами по электронной почте.",
    payoutConfirmBtn: "Запросить выплату",
    payoutConfirmCancel: "Отмена",
  },

  teacherTerms: {
    screenTitle: "Условия партнёрства для преподавателей",
    contents: "Содержание",
    lastUpdatedLabel: "Последнее обновление",
    effectiveLabel: "Дата вступления в силу",
    bannerTitle: "Требуется действие",
    bannerBody: "Пожалуйста, ознакомьтесь с Условиями партнёрства для преподавателей и примите их, чтобы продолжить участие.",
    bannerCta: "Прочитать и принять",
    acceptedOn: "Вы приняли эти Условия {date}.",
    acceptedVersion: "Принятая версия: {version}",
    accepting: "Регистрируем ваше согласие…",
    acceptError: "Не удалось зафиксировать ваше согласие. Пожалуйста, попробуйте ещё раз.",
    draftNotice: "Эти Условия ещё не окончательны. Вы сможете принять их после установления даты вступления в силу.",
  },
};

export default ru;
